import ReportNavigation from 'navigation/ReportNavigation/ReportNavigation';
import { FC } from 'react';
import { Outlet } from 'react-router-dom';
import useReportStyle from './ReportsStyle';

const ReportMain: FC = () => {
  const classes = useReportStyle();
  return (
    <>
      <ReportNavigation />
      <div className={classes.container}>
        <Outlet />
      </div>
    </>
  );
};

export default ReportMain;
